var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @file Popper
 * @author (wangzichuan)
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Popper from 'popper.js';
import { classPrefix, containsAsync } from '../../common/util';

import PortalPopup from './PortalPopup';

import './PopperWrap.less';
/* global document Promise */

/*
 * 参数说明
 * classPrefix         非必需，className前缀
 * containerNode       必需，内容节点
 * popupNode           必需，弹出层节点
 * popupNodeWidth      非必需，弹出层宽度
 * popupNodeClassName  非必需，弹出层类名
 * popupOnBody         非必需，弹出层是否挂在body上
 * placement           非必需，弹出层默认方位：'left', 'right', 'top', 'bottom' + '-start','-end'
 * preventOverflowEnabled    非必需，弹出层固定方向无碰撞效果
 * isShowPopup         非必需，是否显示弹出层
 * popupNodeZIndex     非必需，弹出层的zIndex
 */

var PopperWrap = function (_Component) {
    _inherits(PopperWrap, _Component);

    function PopperWrap() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, PopperWrap);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PopperWrap.__proto__ || Object.getPrototypeOf(PopperWrap)).call.apply(_ref, [this].concat(args))), _this), _this.bodyClick = function (e) {
            var target = e.target;
            var promise1 = containsAsync(_this.popupNodeWrap, target);
            var promise2 = containsAsync(_this.containerNodeWrap, target);

            Promise.all([promise1, promise2]).then(function (_ref2) {
                var _ref3 = _slicedToArray(_ref2, 2),
                    result1 = _ref3[0],
                    result2 = _ref3[1];

                if (_this.isDestroyed) {
                    // 组件已被销毁则不再执行后续内容
                    return;
                }

                if (result1 || result2) {
                    return;
                }
                var onBodyClick = _this.props.onBodyClick;
                onBodyClick && onBodyClick(e);
            });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(PopperWrap, [{
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            document.body.removeEventListener('click', this.bodyClick);
            this.Popper.destroy();
            this.Popper = null;
            this.isDestroyed = true;
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _props = this.props,
                preventOverflowEnabled = _props.preventOverflowEnabled,
                placement = _props.placement;

            this.Popper = new Popper(this.containerNodeWrap, this.popupNodeWrap, {
                placement: placement,
                removeOnDestroy: true,
                modifiers: {
                    preventOverflow: {
                        enabled: preventOverflowEnabled,
                        padding: 0 // 取消当弹出层在边缘时默认5px的padding
                    },
                    hide: {
                        enabled: preventOverflowEnabled
                    }
                }
            });

            document.body.addEventListener('click', this.bodyClick);

            this.isDestroyed = false;
        }
    }, {
        key: 'update',


        // bodyClick = e => {
        //     const target = e.target;
        //     if (
        //         contains(this.popupNodeWrap, target)
        //         || contains(this.containerNodeWrap, target)
        //     ) {
        //         return;
        //     }
        //     const onBodyClick = this.props.onBodyClick;
        //     onBodyClick && onBodyClick(e);
        // }

        value: function update() {
            this.Popper.update();
        }
    }, {
        key: 'render',
        value: function render() {
            var _classnames2,
                _this2 = this;

            var _props2 = this.props,
                containerNode = _props2.containerNode,
                popupNode = _props2.popupNode,
                classPrefix = _props2.classPrefix,
                popupNodeWidth = _props2.popupNodeWidth,
                popupNodeClassName = _props2.popupNodeClassName,
                isShowPopup = _props2.isShowPopup,
                popupOnBody = _props2.popupOnBody,
                popupNodeZIndex = _props2.popupNodeZIndex;

            var containerNodeWrapCls = classnames(_defineProperty({}, classPrefix + '-popper-container-wrap', true));
            var popupNodeWrapCls = classnames((_classnames2 = {}, _defineProperty(_classnames2, classPrefix + '-popper-popup-wrap', true), _defineProperty(_classnames2, popupNodeClassName, !!popupNodeClassName), _defineProperty(_classnames2, 'show', isShowPopup), _classnames2));
            var popupNodeWrapStyle = {};
            popupNodeWidth && (popupNodeWrapStyle.width = popupNodeWidth);
            popupNodeZIndex && (popupNodeWrapStyle.zIndex = popupNodeZIndex);
            return React.createElement(
                'div',
                { ref: function ref(el) {
                        _this2.containerNodeWrap = el;
                    },
                    className: containerNodeWrapCls
                },
                containerNode,
                popupOnBody ? React.createElement(
                    PortalPopup,
                    null,
                    React.createElement(
                        'div',
                        { ref: function ref(el) {
                                _this2.popupNodeWrap = el;
                            },
                            className: popupNodeWrapCls,
                            style: popupNodeWrapStyle
                        },
                        popupNode
                    )
                ) : React.createElement(
                    'div',
                    { ref: function ref(el) {
                            _this2.popupNodeWrap = el;
                        },
                        className: popupNodeWrapCls,
                        style: popupNodeWrapStyle
                    },
                    popupNode
                )
            );
        }
    }]);

    return PopperWrap;
}(Component);

PopperWrap.propTypes = {
    classPrefix: PropTypes.string,
    containerNode: PropTypes.node,
    popupNode: PropTypes.node,
    popupNodeWidth: PropTypes.number,
    popupNodeClassName: PropTypes.string,
    popupOnBody: PropTypes.bool,
    placement: PropTypes.string,
    preventOverflowEnabled: PropTypes.bool,
    isShowPopup: PropTypes.bool,
    popupNodeZIndex: PropTypes.number,
    onBodyClick: PropTypes.func
};
PopperWrap.defaultProps = {
    classPrefix: classPrefix,
    placement: 'bottom-start',
    preventOverflowEnabled: true,
    popupNodeZIndex: 999
};
export default PopperWrap;